export const indicatorsExecutedvsProjected = (chartData) => {
  const cats =
    Array.isArray(chartData?.cats) && chartData.cats.length
      ? chartData.cats
      : ["A", "B", "C", "D"];

  const LEN = cats.length;

  const safeArr = (arr) => {
    if (!Array.isArray(arr)) return Array(LEN).fill(0);
    const out = Array(LEN).fill(0);
    for (let i = 0; i < LEN; i++) {
      const n = Number(arr[i]);
      out[i] = Number.isFinite(n) ? n : 0;
    }
    return out;
  };

  const proy_asignadas = safeArr(chartData?.projected?.proy_asignadas);
  const proy_delegadas = safeArr(chartData?.projected?.proy_delegadas);
  const proy_continuas = safeArr(chartData?.projected?.proy_continuas);

  const eje_asignadas = safeArr(chartData?.executed?.eje_asignadas);
  const eje_delegadas = safeArr(chartData?.executed?.eje_delegadas);
  const eje_continuas = safeArr(chartData?.executed?.eje_continuas);

  const totalProy = cats.map(
    (_, i) => proy_asignadas[i] + proy_delegadas[i] + proy_continuas[i]
  );
  const totalEje = cats.map(
    (_, i) => eje_asignadas[i] + eje_delegadas[i] + eje_continuas[i]
  );
  const pctCumpl = cats.map((_, i) =>
    totalProy[i] ? (100 * totalEje[i]) / totalProy[i] : 0
  );

  const COLOR_ASIG = "#3A7BD5";
  const COLOR_DEL = "#8E44AD";
  const COLOR_CONT = "#16A085";

  return {
    chart: {
      type: "column",
      spacingTop: 40,
      events: {
        render: function () {
          const chart = this;
          if (chart.customLabel) chart.customLabel.destroy();

          chart.customLabel = chart.renderer
            .text(
              "⬅️ <b>Columna izquierda:</b> Planificadas &nbsp;&nbsp; | &nbsp;&nbsp; <b>Columna derecha:</b> Ejecutadas ➡️",
              chart.plotLeft + chart.plotWidth / 2,
              chart.plotTop - 10
            )
            .attr({ align: "center" })
            .css({
              color: "#444",
              fontSize: "13px",
              fontFamily: "Arial, sans-serif"
            })
            .add();
        }
      }
    },

    title: { text: "" },
    subtitle: { text: "" },

    xAxis: {
      categories: cats,
      title: { text: "Categoría" },
      lineWidth: 0
    },

    yAxis: {
      min: 0,
      title: { text: "Cantidad de Actividades" },
      gridLineDashStyle: "ShortDash",
      stackLabels: {
        enabled: true,
        style: { fontWeight: "bold", fontSize: "11px" },
        formatter: function () {
          return this.total;
        }
      }
    },

    legend: {
      align: "center",
      verticalAlign: "bottom",
      itemStyle: { fontSize: "12px" }
    },

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const i = this.points[0].point.index;

        const proy = {
          asignadas: this.series.chart.series[0].data[i].y,
          delegadas: this.series.chart.series[1].data[i].y,
          continuas: this.series.chart.series[2].data[i].y,
          total: totalProy[i]
        };

        const eje = {
          asignadas: this.series.chart.series[3].data[i].y,
          delegadas: this.series.chart.series[4].data[i].y,
          continuas: this.series.chart.series[5].data[i].y,
          total: totalEje[i]
        };

        return `
          <div style="min-width:240px; padding:5px 0">
            <div style="font-size:15px; font-weight:700; color:#444; margin-bottom:8px;">
              Clasificación ${cats[i]}
            </div>

            <div style="font-weight:700; margin-bottom:4px; color:#444;">
              TOTAL Proyectadas <span style="float:right;">${proy.total}</span>
            </div>

            <div style="color:#3A7BD5">Actividades Asignadas <span style="float:right; color:black;">${proy.asignadas}</span></div>
            <div style="color:#8E44AD">Actividades Delegadas <span style="float:right; color:black;">${proy.delegadas}</span></div>
            <div style="color:#16A085">Actividades Continuas <span style="float:right; color:black;">${proy.continuas}</span></div>

            <br>

            <div style="font-weight:700; margin-bottom:4px; color:#444;">
              TOTAL Ejecutadas <span style="float:right;">${eje.total}</span>
            </div>

            <div style="color:#3A7BD5">Actividades Asignadas <span style="float:right; color:black;">${eje.asignadas}</span></div>
            <div style="color:#8E44AD">Actividades Delegadas <span style="float:right; color:black;">${eje.delegadas}</span></div>
            <div style="color:#16A085">Actividades Continuas <span style="float:right; color:black;">${eje.continuas}</span></div>
          </div>
        `;
      }
    },

    plotOptions: {
      column: {
        stacking: "normal",
        grouping: true,
        borderWidth: 0,
        groupPadding: 0.1,
        pointPadding: 0.02,
        dataLabels: {
          enabled: true,
          style: { textOutline: "none", fontSize: "10px" },
          formatter: function () {
            const total = this.total || 0;
            return total > 0 && this.y / total >= 0.15 ? this.y : null;
          }
        }
      }
    },

    series: [
      // PROYECTADAS
      {
        name: "Asignadas",
        data: proy_asignadas,
        color: COLOR_ASIG,
        stack: "Proyectadas",
        showInLegend: true,
        _estado: "Asignadas"
      },
      {
        name: "Delegadas",
        data: proy_delegadas,
        color: COLOR_DEL,
        stack: "Proyectadas",
        showInLegend: true,
        _estado: "Delegadas"
      },
      {
        name: "Continuas",
        data: proy_continuas,
        color: COLOR_CONT,
        stack: "Proyectadas",
        showInLegend: true,
        _estado: "Continuas"
      },

      {
        name: "Asignadas",
        data: eje_asignadas,
        color: COLOR_ASIG,
        stack: "Ejecutadas",
        showInLegend: false,
        _estado: "Asignadas"
      },
      {
        name: "Delegadas",
        data: eje_delegadas,
        color: COLOR_DEL,
        stack: "Ejecutadas",
        showInLegend: false,
        _estado: "Delegadas"
      },
      {
        name: "Continuas",
        data: eje_continuas,
        color: COLOR_CONT,
        stack: "Ejecutadas",
        showInLegend: false,
        _estado: "Continuas"
      }
    ],

    annotations: [
      {
        labels: cats.map((cat, i) => ({
          point: {
            xAxis: 0,
            yAxis: 0,
            x: i,
            y: Math.max(totalProy[i], totalEje[i])
          },
          text: `${pctCumpl[i].toFixed(0)}%`,
          backgroundColor: "rgba(0,0,0,0.06)",
          borderColor: "rgba(0,0,0,0.15)",
          style: { fontSize: "10px", fontWeight: "600" },
          y: -20
        }))
      }
    ],
    credits: {
      enabled: false
    },
    accessibility: { announceNewData: { enabled: true } }
  };
};
